import React, { createContext, forwardRef, useContext, useState } from "react";
import { useParams } from 'react-router-dom';
import {
  CreateButton,
  List,
  Datagrid,
  TextField,
  ResourceContextProvider,
  useRecordContext
} from "react-admin";
import { NodeActions, TreeWithDetails, DeleteMenuItemWithConfirmation } from "src/enterprise/ra-tree";
import { NavigationItemsEdit } from "./NavigationItemsEdit";
import { NavigationItemsCreate } from "./NavigationItemsCreate";
import { NodeActionsProps } from "src/enterprise/ra-tree/NodeActions";

export const NavigationItemsContext = createContext({
  currentParent: null,
  setCurrentParent: null,
});

const NavigationItemsActions = (props: NodeActionsProps) => {
  const { key, title } = props.data;

  return (
    <NodeActions {...props}>
      <DeleteMenuItemWithConfirmation confirmTitle={`Delete ${title} #${key}`}/>
    </NodeActions>
  );
};

export const NavigationItemsList = props => {
  const [currentParent, setCurrentParent] = useState(null);
  const { navigationId } = useParams();

  return (
    <ResourceContextProvider value={`admin/navigations/${navigationId}/items`}>
      <NavigationItemsContext.Provider
        value={{ currentParent, setCurrentParent }}
      >
        <TreeWithDetails
          edit={NavigationItemsEdit}
          create={NavigationItemsCreate}
          addRootButton={<AddRootButton />}
          titleField="title"
          allowMultipleRoots
          draggable
          nodeActions={<NavigationItemsActions />}
        />
      </NavigationItemsContext.Provider>
    </ResourceContextProvider>
  );
};

const AddRootButton = () => {
  const { setCurrentParent } = useContext(NavigationItemsContext);

  return (
    <CreateButton
      label="ra-tree.action.add_root"
      onMouseUp={() => {
        setCurrentParent(null);
      }}
    />
  );
};

